module.exports = __webpack_public_path__ + "img/mitchell-black.20fde95.jpg";